import { Auth } from 'Shared/auth';
import { SentryError } from '@ifixit/sentry';
import type { AuthInstance, AuthResponse, ValidationResponse, RegisterParams } from '../types';

/**
 * Converts Auth.validateLogin callback to Promise for better integration with TanStack Query
 */
export const checkEmailAccountExists = (email: string): Promise<ValidationResponse> =>
   new Promise((resolve, reject) => {
      const auth = Auth as unknown as AuthInstance;

      if (typeof auth.validateLogin !== 'function') {
         reject(new SentryError('Auth.validateLogin is not available'));
         return;
      }

      auth.validateLogin(email, (response: ValidationResponse) => {
         if (!response || typeof response !== 'object') {
            reject(new SentryError('Invalid response from validateLogin'));
            return;
         }
         resolve(response);
      });
   });

/**
 * Converts Auth.sendLoginWithCode callback to Promise for better integration with TanStack Query
 */
export const authenticateWithCode = (email: string, code: string): Promise<AuthResponse> =>
   new Promise((resolve, reject) => {
      const auth = Auth as unknown as AuthInstance;

      void auth.sendLoginWithCode({ login: email, code }, (response: AuthResponse) => {
         if (response.loggedIn) {
            resolve(response);
         } else {
            reject(response);
         }
      });
   });

/**
 * Converts Auth.registerWithCode callback to Promise for better integration with TanStack Query
 */
export const registerWithCode = (params: RegisterParams): Promise<AuthResponse> =>
   new Promise((resolve, reject) => {
      const auth = Auth as unknown as AuthInstance;

      void auth.registerWithCode(params, (response: AuthResponse) => {
         if (response.loggedIn) {
            resolve(response);
         } else {
            reject(response);
         }
      });
   });
